import { render, staticRenderFns } from "./reply-box.vue?vue&type=template&id=39b0dbb0&scoped=true"
import script from "./reply-box.vue?vue&type=script&lang=js"
export * from "./reply-box.vue?vue&type=script&lang=js"
import style0 from "./reply-box.vue?vue&type=style&index=0&id=39b0dbb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b0dbb0",
  null
  
)

export default component.exports